import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LogoutReason } from '@portal-core/auth/enums/logout-reason.enum';
import { InstanceCodeChangeEvent } from '@portal-core/auth/events/instance-code-change.event';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'mc-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginPageComponent implements OnInit {
  logoutReason: LogoutReason;
  instanceCode$: Observable<string>;
  showCentralInstances: boolean;

  constructor(private route: ActivatedRoute, private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.logoutReason = this.route.snapshot.queryParams.reason;
    this.showCentralInstances = this.authService.supportsMultipleCentralInstances;

    this.instanceCode$ = this.route.queryParams.pipe(
      map(queryParams => queryParams.instance)
    );
  }

  onInstanceCodeChanged(event: InstanceCodeChangeEvent) {
    this.router.navigate([], {
      queryParams: { instance: event.instanceCode },
      relativeTo: this.route,
      replaceUrl: !!event.defaulted
    });
  }
}
